/**
 * RotationService — records which way up a photo should be shown.
 *
 * It only ever writes a number to the database. Turning that number into an EXIF
 * marker happens at export time, in ExportService.
 */

import { normaliseDegrees } from '../domain/exif-orientation';
import type { MediaRepository } from '../repositories';
import { noopRecorder, type ChangeSink, type DecisionRecorder } from './ports';

export class RotationService {
  constructor(
    private readonly media: MediaRepository,
    private readonly sink: ChangeSink,
    private readonly journal: DecisionRecorder = noopRecorder,
  ) {}

  /** Turn by a quarter, either direction. Returns the new rotation. */
  rotate(mediaId: number, degrees: number): number | null {
    const item = this.media.byId(mediaId);
    if (!item) return null;

    const next = normaliseDegrees(item.rotation + degrees);
    this.media.setRotation(mediaId, next);
    this.journal.append({ t: 'rotation', id: mediaId, v: next });
    this.sink.touch();
    return next;
  }

  reset(mediaId: number): void {
    this.media.setRotation(mediaId, 0);
    this.journal.append({ t: 'rotation', id: mediaId, v: 0 });
    this.sink.touch();
  }
}
